import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_pass",
  "use": "icon-project_pass-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_pass\"><g transform=\"translate(1 1)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><rect x=\"1\" y=\"3\" width=\"24\" height=\"20\" rx=\"4\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M19 11l-7.215 7L7 13.358\" /><path stroke-linecap=\"round\" d=\"M8.5 0v6M17.5 0v6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol